/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import _ from 'lodash';
import React from 'react';

import { useTrimestreStore } from '@/zustand';

interface ParametresZustandProviderProps {
  children: React.ReactNode;
}

const TrimestreZustandProvider = (props: ParametresZustandProviderProps) => {
  const { children } = props;

  const trimestre = useTrimestreStore((state) => state.trimestre);
  const setIsCurrentTrimestreActif = useTrimestreStore(
    (state) => state.setIsCurrentTrimestreActif,
  );

  const { annee, periode } = trimestre || {};

  React.useEffect(() => {
    if (!_.isNil(trimestre)) {
      const qIndex = periode - 1; // 0..3
      const startMonth = qIndex * 3; // 0,3,6,9
      const nextStart = new Date(annee, startMonth + 3, 1); // exclusif

      const now = new Date();
      // Warn only when the trimestre is past its end date, not when it's in the future
      setIsCurrentTrimestreActif(now < nextStart);
    }
  }, [periode, annee, trimestre, setIsCurrentTrimestreActif]);

  return children;
};

export default TrimestreZustandProvider;
